import "./Login.css";
import { useState, useRef, useEffect } from "react";
import LoginForm from "./LoginForm";
import { useTranslation } from "react-i18next";
import hitachiLogo from "../../assets/hitachi-logo.png";
import worldIcon from "../../assets/world.png"; // Import the world.png image
import { useIsAuthenticated } from "@azure/msal-react";
import { useOktaAuth } from "@okta/okta-react";
import { Navigate } from "react-router-dom";

export const LoginPage = ({ onLogin }) => {
  const { t, i18n } = useTranslation();
  // const selectedLanguage = i18n.language || "en";
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language || "en");
  const [isLangPopupOpen, setIsLangPopupOpen] = useState(false); 
  const { authState } = useOktaAuth(); 
  const isOktaAuthenticated = authState?.isAuthenticated;
  const msalIsAuthenticated = useIsAuthenticated();
  const langPopupRef = useRef(null);
  const langIconRef = useRef(null);

  useEffect(() => {
      const handleClickOutside = (event) => {
        // Check if the click was outside the user icon and popup
        if (
          langPopupRef.current && !langPopupRef.current.contains(event.target) &&
          langIconRef.current && !langIconRef.current.contains(event.target)
        ) {
          setIsLangPopupOpen(false);
        }
      };
  
      // Add event listener
      document.addEventListener('click', handleClickOutside);
  
      // Cleanup the event listener on component unmount
      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }, []);

  if (isOktaAuthenticated || msalIsAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setSelectedLanguage(lng);
    setIsLangPopupOpen(false);
    sessionStorage.setItem("selectedLanguage", lng);
  };

  
  return (
    <div className="login-wrapper">
      <div className="header-logo">
           <div className="top-right-logo">
         
        <img src={hitachiLogo} alt="Hitachi Logo" className="hitachi-logo" />
      </div>
      </div>
   

      <div className="main row">
        <div className="col-sm-4 left-div">
        <div className="form-container">
          <LoginForm onLogin={onLogin} />
        </div>
        </div>
        <div className="col-sm-8">
          <div className="right-div">
             <div className="language-selector">
            <img
              src={worldIcon}
              alt="Languages"
              className="globe-icon"
              onMouseOver={(e) => (e.currentTarget.title = t("preferredLanguage"))}
              onClick={() => setIsLangPopupOpen(!isLangPopupOpen)}
              ref={langIconRef}
            />
            {isLangPopupOpen && (
              <ul className="popup-menu language-options" ref={langPopupRef}>
                <div
                  style={{
                    position: "absolute",
                    top: "-11px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "9px solid transparent",
                    borderRight: "9px solid transparent",
                    borderBottom: "11px solid #ccc",
                    zIndex: 10,
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "-10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "8px solid transparent",
                    borderRight: "8px solid transparent",
                    borderBottom: "10px solid #fff",
                    zIndex: 11,
                  }}
                />
                <li
                  className={`logout-li ${selectedLanguage === "en" ? "selected-language" : ""
                    }`}
                  onClick={() => changeLanguage("en")}
                >
                  {t("english")}
                </li>
                <li
                  className={`logout-li ${selectedLanguage === "jp" ? "selected-language" : ""
                    }`}
                  onClick={() => changeLanguage("jp")}
                >
                  {t("japanese")}
                </li>
                <li
                  className={`logout-li ${selectedLanguage === "ch" ? "selected-language" : ""
                    }`}
                  onClick={() => changeLanguage("ch")}
                >
                  {t("simplifiedChinese")}
                </li>
              </ul>
            )}
          </div>
            <div className="welcome-div">
              <div className="welcome-text-div welcome-intro">{t("welcometo")}</div>
              <div className="welcome-bold-text">
                {t("hitachiGlobalCompliancePlatform")}
              </div>
              <div className="welcome-text-div welcome-para">{t("welcomePara")}</div>
            </div>
        </div>
        </div>
      </div>

      <div className="footer">
        <div className="footer-left">
          {/* <span className="footer-powered-by">{t("poweredBy")}</span> */}
          <strong className="footer-organization1 clipped-footer1">
            {t("hitachiGCO")}
          </strong>
        </div>
        {/* <div className="footer-right">
          <span className="disclaimer-footer-text">
            {t("disclaimerText")}
          </span>
        </div> */}
      </div>
    </div>
  );
};

export default LoginPage;